import type { Identity } from '../store/authStore';

export type IdentityAccessKind = 'direct_guest' | 'group_guest';

type Translate = (key: string, vars?: Record<string, string | number>) => string;

export function isFullCircleIdentity(identity: Pick<Identity, 'role'>): boolean {
  return identity.role !== 'guest';
}

export function getIdentityAccessLabel(identity: Pick<Identity, 'accessKind' | 'role'>, t: Translate): string {
  if (identity.accessKind === 'direct_guest') return t('servers.directGuestAccess');
  if (identity.accessKind === 'group_guest') return t('servers.groupGuestAccess');
  return identity.role ? t(`roles.${identity.role}`) : t('roles.member');
}

export function getIdentityCircleTitle(
  circleLabel: string,
  identity: Pick<Identity, 'accessKind' | 'accessContextLabel'>
): string {
  if (identity.accessKind && identity.accessContextLabel?.trim()) {
    return `${circleLabel} · ${identity.accessContextLabel.trim()}`;
  }
  return circleLabel;
}
